<template>
  <div id="app">
    <a-config-provider :locale="zh_CN">
      <router-view />
    </a-config-provider>
    <a-back-top />
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  name: 'app',
  data() {
    return {
      zh_CN,
    }
  },
}
</script>

<style scoped lang="less">
#app {
  width: 100%;
  min-height: 100%;
  height: 100%;
}
</style>
